import { useLocation } from 'react-router-dom';
import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AlternateLanguageLinks = ({
  languages
}) => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: languages.filter(lang => lang !== getPublicLang()).sort().map(lang => /*#__PURE__*/_jsx("link", {
      href: getProxyUrl(location.pathname, lang),
      hrefLang: lang,
      rel: "alternate"
    }, lang))
  });
};
export default AlternateLanguageLinks;